import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool } from '../../../../helpers/custom-prop-types';
const ProfessionalUnitItemsListMoreCircle = (props) => {
    const { isGuest } = props;
    return (_jsxs("div", Object.assign({ className: 'circle_inner' }, { children: [_jsx("div", Object.assign({ className: 'circle_icon' }, { children: _jsx("i", { className: 'material-icons add' }) })), _jsxs("div", Object.assign({ className: 'circle_text' }, { children: ["\u3059\u3079\u3066\u898B\u308B", isGuest && (_jsxs(_Fragment, { children: [_jsx("br", {}), "\uFF08\u4F1A\u54E1\u767B\u9332\uFF09"] }))] }))] })));
};
ProfessionalUnitItemsListMoreCircle.propTypes = {
    isGuest: propBool().isRequired,
};
export default ProfessionalUnitItemsListMoreCircle;
